export const PACKAGE_NAME = '@atlassian/jira-trial-sprint-board';
export const TEAM_NAME = 'growth-tako';
export const ANALYTICS_SOURCE_NAME = 'trialSprintBoard';
export const TRAIT_NAME = 'jira_premium_sample_project_id';
export const MESSAGE_ID = 'prj-trial-sprint-board_message';
export const STARGATE_URL = '/gateway/api';
